<template>
  <div class="form-group">
    <div class="checkbox" :class="{ '-checked': isChecked, '-express': label === 'true' }">
      <label class="form-check-label" :for="identifier">
        <input :id="identifier" type="checkbox" :name="identifier" :value="value" v-model="checkboxValue">
        <span v-if="label !== 'true'">{{ label }}</span>
        <span v-else><img class="express-img" src="../../assets/express.jpeg" height="23" width="100" alt="express"/></span>
      </label>
      <a v-if="label === 'true'" target="_blank" :href="globals.expressLink" class="express-info icon-tooltip-before"></a>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { useGlobalStore } from '@/stores'

const globals = useGlobalStore()

const props = defineProps({
    identifier: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    value: {
        type: Object,
        default: null
    },
    modelValue: {
        type: [Boolean, Array],
        default: null
    }
})

const emit = defineEmits(['update:modelValue', 'handleTracking'])

const checkboxValue = computed({
    get () {
        return props.modelValue
    },
    set (value) {
        emit('update:modelValue', value)
        emit('handleTracking', isChecked)
    }
})

const isChecked = computed(() => {
    let arr = props.modelValue.filter((obj) => {
      return obj.searchTerm === props.value.searchTerm
    })
    return arr.length
})
</script>
